module.exports = __webpack_public_path__ + "img/faqup.e351b513.png";